<template>
  <v-card flat class="mb-7">
    <v-card-text class="pa-5 success">
      <div class="d-flex align-center">
        <div class="align-self-center">
          <h1 class="white--text display-1">
          </h1>
        </div>
        <div class="mr-4">
          <h3 class="card-title white--text title font-weight-regular">{{title}}</h3>
          <h4 class="card-subtitle white--text op-3 subtitle-2 font-weight-regular" v-if='title == "Programs Logged"'>How many programs have been <strong>logged?</strong></h4>
          <h4 class="card-subtitle white--text op-3 subtitle-2 font-weight-regular" v-else>How many programs have been <strong>scheduled?</strong></h4>
        </div>
      </div>
      <v-row class="mt-2">
        <v-col cols="4" class="d-flex align-center">
          <h2 class="font-weight-bold white--text text-nowrap" v-if='title == "Programs Logged"'>{{count}}</h2>
        </v-col>
        <v-col cols="8">
          <div class="float-right" v-show="elementVisible">
            <vue-apex-charts
              type="bar"
              height="70px"
              width="150px"
              :options="DownloadChart.DownloadChart.chartOptions"
              :series="DownloadChart.DownloadChart.series"
            ></vue-apex-charts>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import DownloadChart from "./DownloadData";

export default {
  name: "ProgramsLogged",
  props: ['title','count'],
  data: () => ({
    elementVisible: false,
    DownloadChart: DownloadChart
  }),
  created() {
    setTimeout(() => (this.elementVisible = true), 1000);
  },
  components: {
    VueApexCharts
  }
};
</script>